export const getCategoriesUrl = '/primary_facade/offerings/categories';
export const getOfferingsUrl = '/primary_facade/v2/offerings';
export const getOfferingsClientUrl = '/api/offerings';
